
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ValidationObserver } from 'vee-validate';
import { Validate } from '@/types';
import { PERMISSION } from '@/permissions';
import Availability from '@/components/menu/form/Availability.vue';

const namespace: string = 'menus';

@Component<MenuHours>({
	components: {
		ValidationObserver,
		Availability
	}
})
export default class MenuHours extends Vue {
	@Getter('getMenus', { namespace }) private menus!: Menu[];
	@Getter('hasPermission', { namespace: 'auth' }) private hasPermission!: (permission: PERMISSION) => boolean;

	$refs!: { observer: Validate };

	private PERMISSION = PERMISSION;
	private showSaveBtn: boolean = false;
	private menuSelected: any = null;

	private mounted(): void {
		this.positionSaveButton();
	}

	/**
	 * Position save button depending on the drawer size when changing
	 * menu tab
	 *
	 * @return {void}
	 */
	private positionSaveButton(): void {
		this.showSaveBtn = false;
		setTimeout(() => {
			const drawer = document.getElementById('nav-drawer');
			if(drawer) {
				document.documentElement.style.setProperty('--dynamic-btn-left-value', `${drawer.offsetWidth}px`);
			}
			this.showSaveBtn = true;
		}, 400);
	}
}
